import { render, staticRenderFns } from "./DashboardPosturasByStatus.vue?vue&type=template&id=566b65d6&scoped=true"
import script from "./DashboardPosturasByStatus.vue?vue&type=script&lang=js"
export * from "./DashboardPosturasByStatus.vue?vue&type=script&lang=js"
import style0 from "./DashboardPosturasByStatus.vue?vue&type=style&index=0&id=566b65d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b65d6",
  null
  
)

export default component.exports